export const categories = [
  { id: 1, name: "网红塌房", slug: "influencer-collapse", icon: "ri-alert-line", count: 1286 },
  { id: 2, name: "明星爆料", slug: "celebrity-reveal", icon: "ri-star-line", count: 956 },
  { id: 3, name: "每日大赛", slug: "daily-contest", icon: "ri-fire-line", count: 743 },
  { id: 4, name: "匿名黑料", slug: "anonymous-tips", icon: "ri-spy-line", count: 521 },
  { id: 5, name: "辟谣专区", slug: "rumor-debunk", icon: "ri-shield-check-line", count: 312 },
  { id: 6, name: "吃瓜合集", slug: "chigua-collection", icon: "ri-archive-line", count: 467 },
];

export const articles = [
  {
    id: 1,
    title: "知名带货主播小杨哥直播翻车，产品质量遭全网质疑",
    slug: "xiaoyangge-livestream-scandal",
    category: "网红塌房",
    categorySlug: "influencer-collapse",
    excerpt: "知名带货主播「小杨哥」在近日的一场直播中被曝出售卖的三无产品存在严重质量问题，引发全网热议。多位消费者晒出购买记录和产品实物照片，控诉产品质量低劣、货不对板。",
    content: "近日，拥有千万粉丝的知名带货主播「小杨哥」在直播中推销的一款「美容仪」产品被大量消费者投诉。据悉，该产品实际功效与直播宣传严重不符，且产品包装上没有任何正规的生产批号和质量认证标志。\n\n据消费者反映，该产品使用后出现了皮肤过敏、红肿等不良反应。更令人震惊的是，有消费者将产品送检后发现，产品成分中竟然含有超标的违禁物质。\n\n这并非小杨哥第一次陷入产品质量争议。早在去年，其带货的一款保健品就曾被质疑虚假宣传。对此，小杨哥方面目前尚未作出正式回应。\n\n业内人士分析认为，直播带货行业亟需加强监管，平台方也应当承担起相应的审核责任，保护消费者的合法权益。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20livestreaming%20studio%20scene%20with%20red%20warning%20alert%20on%20screen%2C%20scattered%20product%20boxes%20on%20table%2C%20cinematic%20lighting%2C%20warm%20amber%20and%20red%20tones%2C%20dark%20background%2C%20editorial%20photography%2C%20dramatic%20atmosphere%2C%20investigative%20journalism%20style&width=1200&height=600&seq=article-01&orientation=landscape",
    time: "2026-07-07 14:30",
    source: "51暗网吃瓜编辑部",
    views: 156230,
    tags: ["小杨哥", "直播带货", "产品质量", "消费者维权"],
  },
  {
    id: 2,
    title: "某顶流男星深夜密会神秘女子，酒店监控画面流出",
    slug: "top-star-hotel-scandal",
    category: "明星爆料",
    categorySlug: "celebrity-reveal",
    excerpt: "近日，一段某顶流男星深夜与神秘女子共同进入酒店的监控画面在网络上疯传，引发粉丝和网友的激烈讨论。画面显示两人举止亲密，疑似新恋情曝光。",
    content: "7月6日深夜，有网友在社交平台发布了一段疑似某顶流男星的酒店监控视频。视频中可以看到，该男星与一名年轻女子于凌晨1点左右先后进入某五星级酒店，两人全程保持距离但明显相识。\n\n视频发布后迅速登上热搜，粉丝群体出现严重分化。一部分粉丝表示「如果是真的就祝福」，但更多铁粉则情绪激动，后援会甚至出现了大规模脱粉现象。\n\n截至目前，该男星的工作室尚未对此事作出任何回应。有媒体尝试联系其经纪人，电话始终无人接听。\n\n娱乐圈资深评论人士表示，明星的私人生活一直是公众关注的焦点，但也呼吁大家理性看待，不要过度解读。",
    imageUrl: "https://readdy.ai/api/search-image?query=Blurry%20night%20scene%20at%20luxury%20hotel%20entrance%2C%20two%20silhouettes%20walking%2C%20paparazzi%20style%2C%20warm%20street%20lights%20glow%2C%20dark%20atmosphere%2C%20cinematic%20composition%2C%20mysterious%20vibe%2C%20neon%20signs%20in%20background%2C%20high%20contrast&width=1200&height=600&seq=article-02&orientation=landscape",
    time: "2026-07-07 09:15",
    source: "51暗网吃瓜编辑部",
    views: 234500,
    tags: ["顶流男星", "恋情曝光", "酒店", "粉丝脱粉"],
  },
  {
    id: 3,
    title: "某知名女团成员疑似恋情曝光，粉丝后援会集体脱粉",
    slug: "girl-group-dating-rumor",
    category: "明星爆料",
    categorySlug: "celebrity-reveal",
    excerpt: "某当红女团成员被拍到与圈外男子多次约会的画面，虽然经纪公司火速辟谣，但粉丝后援会已宣布集体脱粉。",
    content: "近日，某当红女团的人气成员被狗仔拍到与一名圈外年轻男子在北京三里屯附近多次约会的画面。照片中两人有说有笑，互动十分亲密。\n\n虽然经纪公司在事件发酵后火速发布声明「两人只是普通朋友」，但这一回应并未平息粉丝的愤怒。该成员的个人粉丝后援会随后发布公告，宣布「由于偶像多次欺骗粉丝感情，后援会即日起解散」。\n\n据不完全统计，该事件导致该成员个人社交账号一夜之间掉粉超过50万。业内人士表示，偶像恋爱在日韩娱乐圈早已是敏感话题，在国内虽然舆论环境相对宽松，但对于以「男友粉」「女友粉」为主的偶像来说，恋爱仍然是一大禁忌。",
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20single%20spotlight%2C%20scattered%20fan%20support%20items%20on%20ground%2C%20melancholic%20atmosphere%2C%20warm%20golden%20spotlight%2C%20dark%20background%2C%20cinematic%20composition%2C%20emotional%20aftermath%20scene&width=1200&height=600&seq=article-03&orientation=landscape",
    time: "2026-07-06 18:45",
    source: "51暗网吃瓜编辑部",
    views: 187600,
    tags: ["女团", "恋情", "脱粉", "偶像恋爱"],
  },
  {
    id: 4,
    title: "百万粉美食博主被曝后厨卫生堪忧，顾客吃出异物",
    slug: "food-blogger-hygiene-scandal",
    category: "网红塌房",
    categorySlug: "influencer-collapse",
    excerpt: "拥有百万粉丝的美食博主「大嘴吃四方」被前员工实名举报后厨卫生脏乱差，更有顾客晒出在菜品中吃出蟑螂的照片。",
    content: "近日，一位自称是美食博主「大嘴吃四方」前员工的网友在社交平台发布长文，详细曝光了该博主名下多家餐厅的后厨乱象。\n\n爆料内容触目惊心：食材未按要求储存、厨具长期不清洗、蟑螂老鼠横行、使用过期调料等等。更令人作呕的是，该博主曾在视频中展示的「秘制酱料」竟是在肮脏环境下制作的。\n\n随后，多名曾在该博主餐厅消费的顾客也纷纷晒出「吃出异物」的照片和视频证据。市场监管部门已介入调查，相关门店已被责令停业整顿。\n\n「大嘴吃四方」本人目前尚未对此事作出回应，但其所有社交账号评论区已被愤怒的网友攻陷。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20messy%20restaurant%20kitchen%20with%20dirty%20surfaces%2C%20dramatic%20overhead%20lighting%2C%20health%20violation%20scene%2C%20warm%20yellow%20light%20casting%20shadows%2C%20cinematic%20composition%2C%20gritty%20investigative%20style%2C%20dark%20corners&width=1200&height=600&seq=article-04&orientation=landscape",
    time: "2026-07-06 11:20",
    source: "51暗网吃瓜编辑部",
    views: 98700,
    tags: ["美食博主", "卫生问题", "后厨", "食品安全"],
  },
  {
    id: 5,
    title: "知名导演被多名女演员实名举报潜规则，聊天记录曝光",
    slug: "director-metoo-allegations",
    category: "匿名黑料",
    categorySlug: "anonymous-tips",
    excerpt: "一位知名导演被至少五名女演员实名举报在选角过程中存在不当行为，其中多段聊天记录截图已公开。",
    content: "娱乐圈再爆大瓜！近日，多位女演员通过社交媒体实名举报某知名导演在选角过程中存在不当行为。\n\n据悉，该导演以「试戏」为名，多次要求女演员进行「私下一对一指导」，并在深夜发送大量不当言论。有女演员公开了与导演的微信聊天记录，内容令人震惊。\n\n目前已有至少五位女演员站出来发声，控诉该导演的恶劣行为。其中一位女演员表示：「忍了很多年，今天终于有勇气说出来了。」\n\n该导演方面发布声明否认所有指控，称「这是有组织的恶意造谣」，并表示将通过法律途径维护自身权益。但业内人士透露，多家影视公司已暂停与该导演的合作。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20room%20with%20documents%20and%20phone%20on%20desk%20showing%20blurry%20chat%20messages%2C%20dramatic%20single%20light%20source%2C%20investigative%20atmosphere%2C%20warm%20desk%20lamp%20glow%2C%20cinematic%20composition%2C%20whistleblower%20theme%2C%20dark%20moody%20background&width=1200&height=600&seq=article-05&orientation=landscape",
    time: "2026-07-05 20:00",
    source: "51暗网吃瓜编辑部",
    views: 278400,
    tags: ["导演", "潜规则", "实名举报", "MeToo"],
  },
  {
    id: 6,
    title: "某选秀冠军涉税务问题被调查，金额高达数千万",
    slug: "talent-show-winner-tax-investigation",
    category: "明星爆料",
    categorySlug: "celebrity-reveal",
    excerpt: "据知情人士透露，某知名选秀节目冠军近日因涉嫌偷税漏税被税务部门约谈，涉案金额或高达数千万元。",
    content: "继多位明星因税务问题翻车之后，又一位重量级人物卷入其中。据知情人士透露，某选秀节目冠军近日被税务部门约谈，涉嫌偷逃税款。\n\n据悉，该明星通过设立多家空壳公司、签订阴阳合同等方式，在近三年内偷逃税款金额可能高达3000万元以上。目前税务部门已掌握相关证据，案件正在进一步调查中。\n\n消息传出后，该明星代言的多个品牌已紧急下架相关宣传物料，部分品牌甚至单方面宣布解约。粉丝群体陷入巨大震动，后援会发布声明「静待官方通报」。\n\n值得注意的是，这已经是今年以来第三起明星税务案件。业内人士呼吁娱乐圈应当加强自律，依法纳税是每个公民应尽的义务。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20office%20with%20stacks%20of%20financial%20documents%20and%20red%20stamp%20marks%2C%20dramatic%20desk%20lamp%20lighting%2C%20tax%20investigation%20theme%2C%20warm%20amber%20light%2C%20cinematic%20composition%2C%20serious%20legal%20atmosphere%2C%20dark%20wood%20desk&width=1200&height=600&seq=article-06&orientation=landscape",
    time: "2026-07-05 16:30",
    source: "51暗网吃瓜编辑部",
    views: 312500,
    tags: ["选秀冠军", "税务问题", "偷税漏税", "品牌解约"],
  },
];